<template>
  <el-container>
    <el-header style="padding: 0" height="240">
      <Header></Header>
    </el-header>
    <el-main style="width: 85%;min-height:70vh;margin: 0 auto;padding: 0">
        <router-view :key="$route.fullPath"></router-view>
    </el-main>
    <el-footer style="padding: 0;margin-top: 20px">
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
import Footer from "../src/components/Footer";
import Header from "../src/components/Header";

export default {
  name: 'App',
  components: {Footer, Header}
}
</script>

<style>

</style>
